import Turnus from 'src/models/Turnus';
import Objednavka from 'src/models/Objednavka';

class NewOrderResponse {
    public id: number;
    public objednavka: Objednavka;
    public turnusy: Turnus[] = [];
}

export default NewOrderResponse;


// WEBPACK FOOTER //
// ./src/services/response/NewOrderResponse.tsx